import { render } from "./AddInspection.vue?vue&type=template&id=22fceae6&lang=true"
import script from "./AddInspection.vue?vue&type=script&lang=js"
export * from "./AddInspection.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/0EA9C00323D8BFD1/Code/ptbcs-quasar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QInput,QIcon,QTd});
